





































































import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { Alert, AlertMessage, ErrorMessage, systemUserApi } from '@/api'
import {
  alertStore,
  authUserStore,
  modalErrorStore
} from '@/utils/store-accessor'
import { AlertFactory } from '@/factory'
import { AlertCodeAL600001, AlertCodeML600003 } from '@/types'

interface ModalPasswordChangeItem {
  password: {
    input: string
    errorMessage: string
    visibility: boolean
  }
  passwordNew: {
    input: string
    errorMessage: string
    visibility: boolean
  }
  passwordNewConfirm: {
    input: string
    errorMessage: string
    visibility: boolean
  }
}

const defaultModalPasswordChangeItem = (): ModalPasswordChangeItem => ({
  password: {
    input: '',
    errorMessage: '',
    visibility: false
  },
  passwordNew: {
    input: '',
    errorMessage: '',
    visibility: false
  },
  passwordNewConfirm: {
    input: '',
    errorMessage: '',
    visibility: false
  }
})

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalPasswordChange extends ComponentVue {
  dialog: boolean = false

  inputItem: ModalPasswordChangeItem = defaultModalPasswordChangeItem()

  get passwordMask(): string {
    return 'X'.repeat(32)
  }

  get inputAppendIcon(): (visibility: boolean) => string {
    return visibility => {
      return visibility ? 'mdi-eye' : 'mdi-eye-off'
    }
  }

  get inputTextType(): (visibility: boolean) => string {
    return visibility => {
      return visibility ? 'text' : 'password'
    }
  }

  ok(): void {
    const alert: Alert = AlertFactory.create(AlertCodeAL600001)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: this.updateSystemUserPassword
    })
  }

  open(): void {
    this.dialog = true
  }

  close(): void {
    this.dialog = false
    this.inputItem = defaultModalPasswordChangeItem()
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onClickAppendIcon(obj: any): void {
    obj.visibility = !obj.visibility
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  async updateSystemUserPassword(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await systemUserApi.updateSystemUserPassword({
        password: this.inputItem.password.input,
        passwordNew: this.inputItem.passwordNew.input,
        passwordNewConfirm: this.inputItem.passwordNewConfirm.input
      })

      const alert: Alert = AlertFactory.create(
        AlertCodeML600003,
        authUserStore.authUser.userId
      )
      alertStore.setItem(alert)
      this.$modalAlert.open({
        onOkClick: this.close
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, this.inputItem)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
